/**
 * R5Ribbon
 * -----------------------------------------------------------
 * Brass diagonal ribbon used on token-pack "Most Popular"
 * card and similar feature highlights. Positions itself
 * absolutely; place inside a card with `position: relative`.
 */
import React from 'react';

export function R5Ribbon({ children = '★ Most Popular', className = '', ...rest }) {
  const cls = ['r5-ribbon', className].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}

export default R5Ribbon;
